var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 40,
    r: 40,
    fill: "#000",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9CAD3",
    stroke: "#C9CAD3",
    strokeWidth: 2,
    d: "M9.177 27a1 1 0 00-.98.8L1.02 62.985a1 1 0 00.98 1.2h49.62a6 6 0 012.06.365l2.946 1.077a4 4 0 002.748 0l2.946-1.077a6 6 0 012.06-.365H114a1 1 0 00.98-1.2L107.801 27.8a1 1 0 00-.98-.8H9.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#C9CAD3",
    strokeWidth: 2,
    d: "M9.177 23a1 1 0 00-.98.8L1.02 58.985a1 1 0 00.98 1.2h49.62a6 6 0 012.06.365l2.946 1.077a4 4 0 002.748 0l2.946-1.077a6 6 0 012.06-.365H114a1 1 0 00.98-1.2L107.801 23.8a1 1 0 00-.98-.8H9.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#C9CAD3",
    strokeWidth: 2,
    d: "M14.468 24.668a1 1 0 00-.743.77L7.588 55.246a1 1 0 001.17 1.184C20.539 54.144 30.618 53 39 53c7.388 0 13.257.888 17.62 2.684a1 1 0 001.38-.925V25.117a1 1 0 00-.507-.87C53.692 22.093 48.193 21 41 21c-7.604 0-16.45 1.221-26.532 3.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#C9CAD3",
    strokeWidth: 2,
    d: "M101.532 24.668a1 1 0 01.743.77l6.137 29.808a1 1 0 01-1.17 1.184C95.461 54.144 85.382 53 77 53c-7.388 0-13.257.888-17.62 2.684a1 1 0 01-1.38-.925V25.117a1 1 0 01.507-.87C62.308 22.093 67.807 21 75 21c7.604 0 16.45 1.221 26.532 3.668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9CAD3",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M95 32c-8.49-1.333-14.654-2-18.49-2-3.837 0-7.673.667-11.51 2m31 5c-9.157-1.333-15.654-2-19.49-2-3.837 0-7.673.667-11.51 2m32 5c-9.823-1.333-16.653-2-20.49-2-3.837 0-7.673.667-11.51 2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9CAD3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.243 26l4.215 4.216c1.87 1.869 1.518 2.891 1.554 3.336.036.446-.136 1.238 1.448 2.822l8.776 8.777c.557.557.572 1.054.288 1.337l-.034.034c-.284.284-.782.268-1.338-.287l-8.776-8.777c-1.584-1.583-2.432-1.445-2.822-1.448-.39-.002-1.566.215-3.336-1.555L24 30.243m1.025-1.511l4.243 4.243M27 27.707l4.243 4.243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#C9CAD3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M45.385 28L33.718 39.666c-.32.32-.443.76-.366 1.163l-5.376 5.377c-.319.319-.328.827-.02 1.134.307.308.815.299 1.134-.02l5.271-5.27a1.29 1.29 0 001.479-.262l8.612-8.612c2.533-2.533.933-5.176.933-5.176z"
  }))));
}
export default SvgBook;